import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { ajax } from "jquery";

import ElementMessage from '../../components/common/elementmessage';
import InlineData from '../../components/forms/inlinedata';
import Button from '../../components/forms/button';
import * as CONST from '../../helpers/const';
import { isMobile } from 'react-device-detect';

const FilterForm = (props) => {
    const [filterPostalCode, setFilterPostalCode] = useState("");
    const [filterPhoneNumber, setFilterPhoneNumber] = useState("");
    const [filterFacilityName, setFilterFacilityName] = useState("");

    function findProducts() {
        props.setShowResultTable(true);
        $("#loading").fadeIn();
        var filterModel = {
            PostalCode: filterPostalCode,
            PhoneNumber: filterPhoneNumber,
            FacilityName: filterFacilityName
        };
        ajax({
            url: props.GetCartInfoUrl,
            type: 'POST',
            data: { 'filterData': filterModel },
            credentials: 'same-origin'
        }).done(json => {
            let result = JSON.parse(json);
            if (result.Status === CONST.ApiResult.Success) {
                let list = result.Response || [];
                props.setResultCount && props.setResultCount(list.length);
                props.setHasSearched && props.setHasSearched(true);
                props.setNewProducts(list);

                if (list.length === 0) {
                    const msg = [
                        props.getTranslateValue(props.translate.current, "views.iac0101.info7"),  
                        props.getTranslateValue(props.translate.current, "views.iac0101.info8"),  
                        props.getTranslateValue(props.translate.current, "views.iac0101.info9"),  
                        props.getTranslateValue(props.translate.current, "views.iac0101.info10"), 
                        props.getTranslateValue(props.translate.current, "views.iac0101.info11")  
                    ].join("\\n");

                    props.setStatus && props.setStatus(CONST.ApiResult.Error);
                    props.setMessage && props.setMessage(msg);
                } else {
                    props.clearMessage && props.clearMessage();
                }
            }
            else {
                props.setStatus && props.setStatus(CONST.ApiResult.Error);
                props.setMessage && props.setMessage(result.Message);
            }
        }).fail(json => {
            props.setNewProducts(props.selectedProducts);
            props.setResultCount && props.setResultCount(0);
            props.setHasSearched && props.setHasSearched(true);

            const msg = props.getTranslateValue(props.translate.current, "messages.common.norecord");
            props.setStatus && props.setStatus(CONST.ApiResult.Error);
            props.setMessage && props.setMessage(msg);
        }).always(json => {
            $("#loading").fadeOut();
        })

    }
    if ( isMobile ) {
        return (
            <div>
                <div className="col-md-12">
                    <div className="row form-group" style={{ alignItems: "center" }}>
                        {/* Postal code */}
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", marginBottom: 10 }}>
                                <label htmlFor="postalCode" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.postalcode")}</label>
                                <input id="postalCode" name="postalCode" type="text" inputMode="numeric" className="form-control" value={filterPostalCode} placeholder={props.getTranslateValue(props.translate.current, "views.iac0101.numberplaceholder")} onChange={e => {
                                    var onlydigits = e.target.value.replace(/\D/g, "");  
                                    setFilterPostalCode(onlydigits)
                                }}/>
                            </div>
                        </div>
                        {/* Phone number */}
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch" ,marginBottom: 10}}>
                                <label htmlFor="phoneNumber" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.phonenumber")}</label>
                                <input id="phoneNumber" name="phoneNumber" type="text" inputMode="numeric" className="form-control" value={filterPhoneNumber} placeholder={props.getTranslateValue(props.translate.current, "views.iac0101.numberplaceholder")} onChange={e => {
                                    var onlydigits = e.target.value.replace(/\D/g, "");  
                                    setFilterPhoneNumber(onlydigits)
                                }}/>
                            </div>
                        </div>
                        {/* Facility name */}
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch"}}>
                                <label htmlFor="facilityName" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.facilityname")}</label>
                                <input id="facilityName" name="facilityName" type="text" className="form-control" value={filterFacilityName} onChange={e => setFilterFacilityName(e.target.value)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ marginBottom: 20 }}>
                    <div className="row form-group" style={{ margin: "auto", width: "90%"}}>
                        <div className="text-center">
                            <Button color="Success" className="flex-grow-0 btnSearch" onClick={findProducts.bind(this)}
                                label={
                                    <span style={{fontWeight: "bold"}}>
                                        {props.getTranslateValue(props.translate.current, "views.iac0101.searchfacilityname")}
                                        <i className="fa fa-search" style={{ marginLeft: 12 }} />
                                    </span>
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div>
            <div className="col-md-12">
                <div className="row form-group" style={{ alignItems: "center" }}>
                    {/* Postal code */}
                    <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="input-group-text" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <label htmlFor="postalCode" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.postalcode")}</label>
                            <input id="postalCode" name="postalCode" type="text" inputMode="numeric" className="form-control" value={filterPostalCode} placeholder={props.getTranslateValue(props.translate.current, "views.iac0101.numberplaceholder")} onChange={e => {
                                var onlydigits = e.target.value.replace(/\D/g, "");  
                                setFilterPostalCode(onlydigits)
                            }}/>
                        </div>
                    </div>
                    {/* Phone number */}
                    <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="input-group-text" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <label htmlFor="phoneNumber" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.phonenumber")}</label>
                            <input id="phoneNumber" name="phoneNumber" type="text" inputMode="numeric" className="form-control" value={filterPhoneNumber} placeholder={props.getTranslateValue(props.translate.current, "views.iac0101.numberplaceholder")} onChange={e => {
                                var onlydigits = e.target.value.replace(/\D/g, "");  
                                setFilterPhoneNumber(onlydigits)
                            }}/>
                        </div>
                    </div>
                    {/* Facility name */}
                    <div className="col-md-4 col-sm-4 col-xs-12">
                        <div className="input-group-text" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <label htmlFor="facilityName" style={{ minWidth: 85, textAlign: "left", marginBottom: 0 }}>{props.getTranslateValue(props.translate.current, "views.iac0101.facilityname")}</label>
                            <input id="facilityName" name="facilityName" type="text" className="form-control" value={filterFacilityName} onChange={e => setFilterFacilityName(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12" style={{ marginBottom: 20 }}>
                <div className="row form-group" style={{ margin: "auto" }}>
                    <div className="col-md-offset-5 col-md-2 col-sm-offset-5 col-sm-2 col-xs-offset-4 col-md-4 text-center">
                        <Button color="Success" className="flex-grow-0 btnSearch" onClick={findProducts.bind(this)}
                            label={
                                <span>
                                    {props.getTranslateValue(props.translate.current, "views.iac0101.searchfacilityname")}
                                    <i className="fa fa-search" style={{ marginLeft: 12 }} />
                                </span>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterForm;


// WEBPACK FOOTER //
// ./view/IAC0100/iac0100-filter.jsx